import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './translations/enUS';
import idID from './translations/idID';

const resources = {
  en: {
    translation: enUS
  },
  id: {
    translation: idID
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });
